import { HeaderMenuBreadcrumb } from '@publicisgroupe/p-os-components';
import classNames from 'classnames';
import LayoutHeader from 'components/LayoutHeader';
import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { ROUTE_ROOT } from 'utils/routes';

interface ErrorProps {
  headerText: string;
  bodyText: string;
  breadcrumbs?: HeaderMenuBreadcrumb[];
  hideContainerClass?: boolean;
  navigateToRootUrl?: boolean;
}

export const ErrorPage = ({
  headerText,
  bodyText,
  breadcrumbs,
  hideContainerClass,
  navigateToRootUrl,
}: ErrorProps) => {
  const history = useHistory();

  const defaultBreadcrumbs = [
    {
      name: 'Home',
      onClick: () => navigationHandler(ROUTE_ROOT),
    },
  ] as HeaderMenuBreadcrumb[];

  const navigationHandler = useCallback(
    (route: string) => {
      if (navigateToRootUrl) {
        window.location.href = `${ROUTE_ROOT}`;
      } else {
        history.push(route);
      }
    },
    [navigateToRootUrl, history]
  );

  return (
    <div
      className={classNames({
        'ui container module-container': !hideContainerClass,
      })}
    >
      <LayoutHeader breadcrumbs={breadcrumbs ?? defaultBreadcrumbs} title={headerText} />
      <main style={{ display: 'flex', flexDirection: 'column' }}>
        <div className="configuration-contents" data-testid={`resource-not-found`}>
          <h4>{bodyText}</h4>
        </div>
      </main>
    </div>
  );
};
